export enum AppRole {
  Visitor = 'Visitor',
}

export enum ProfessionType {
  Developer = "Developer",
  Designer = "Designer",
  Translator = "Translator",
  Tester = "Tester",
  Other = "Other"
}

export enum PaymentStatus {
  Pending = "Pending",
  Paid = "Paid",
  Canceled = "Canceled"
}

export enum PaymentType {
  OneTime = "OneTime",
  Recurring = "Recurring"
}

export enum ClientStatus {
  Live = "Live"
}

export enum SetupStatus {
  SelectPlan = "selectPlan",
  OpeningHours = "openingHours",
  DeliveryOptions = "deliveryOptions",
  MenuSetup = "menuSetup",
  TeamInvite = "teamInvite",
  Publish = "publish",
  Live = "Live"
}

export enum SubscriptionInterval { // Stripe values
  Week = "week",
  Month = "month",
  Year = "year"
}

export enum SubscriptionStatus {
  Pending = "Pending",
  Active = "Active",
  NotPaid = "NotPaid",
  Ended = "Ended"
}

export enum LicenseType {
  Starter = "starter",
  Basic = "basic",
  Business = "business",
}

export enum FoodOrderDeliveryType {
  Delivery = "delivery",
  PickUp = "pickUp",
  Table = "table",
}

export enum EatInPlaceType {
  Counter = "counter",
  Table = "table",
  Room = "room",
  ParkingSpot = "parkingSpot",
}

export enum StorePageType {
  Main = "main",
  Contact = "contact",
  Custom = "custom",
}

export enum UserStoreRole {
  Owner = "Owner",
  Employee = "Employee",
}

export enum FoodOrderStatus {
  Pending = "pending",
  Accepted = "accepted",
  Rejected = "rejected",
  Done = "done",
}

export enum PaymentMethod {
  Cash = "cash",
  Card = "card",
  Blik = "blik",
  Online = "online",
}

export enum RefundFailureReason {
  InsufficientFunds = "insufficientFunds",
  Unknown = "unknown",
}

export enum FoodOrderPaymentStatus {
  NotRequired = "notRequired",
  Pending = "pending",
  Paid = "paid",
  Failed = "failed",
  Refunded = "refunded",
}

export enum BlogLanguage {
  English = "en",
  Spanish = "es",
  Polish = "pl",
}
